var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _ellipse, _ellipse2, _ellipse3, _circle0, _circle1, _circle10, _circle11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgCircles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 1000,
    viewBox: "0 0 550 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 441,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 637,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 833,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 441,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 441,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 637,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 637,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 833,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 833,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296,
    cy: 245.5,
    rx: 98,
    ry: 96.5,
    stroke: "white",
    strokeWidth: 3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 245.5,
    rx: 98,
    ry: 96.5,
    stroke: "white",
    strokeWidth: 3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 492,
    cy: 245.5,
    rx: 98,
    ry: 96.5,
    stroke: "white",
    strokeWidth: 3
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 50,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 50,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 50,
    r: 98,
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCircles);
export default __webpack_public_path__ + "static/media/bg-circles.94cf39f19b4d3e878cf637ed21686c85.svg";
export { ForwardRef as ReactComponent };